import { createContext } from "react";

export const SnackContext = createContext({});

export const SnackContextProvider = (props) => {
  return (
    <SnackContext.Provider value={{}}>
      {props.children}
    </SnackContext.Provider>
  );
};
